import {
  ALL_CHART_TYPES,
  BLACK_HEX,
  DEFAULT_LINE_THICKNESS,
  DEFAULT_NORMALIZE_BY,
  DEFAULT_NORMALIZE_BY_SETTING
} from "constants/chart.constants";
import { EvaSource, TimeStep } from "constants/charts.enums";
import { createMergeWithDefaults } from "entities/utils";
import { DeclineRateChartRequestType, DeclineRateChartSettings } from "types";

import { MaxBinsSortOrderEnum } from "models/binSize";
import { EntityKind } from "models/entityKind";

import { BASE_CHART_REQUEST } from "./defaults";

export const DEFAULT_DECLINE_RATE_CHART_SETTINGS: Partial<DeclineRateChartSettings> = {
  product: "Oil",
  chartType: ALL_CHART_TYPES.BaseDeclineRate.id,
  showForecast: false,
  averageSettings: {
    color: BLACK_HEX,
    thickness: DEFAULT_LINE_THICKNESS
  },
  showAverage: false,
  p10Settings: {
    color: BLACK_HEX,
    thickness: DEFAULT_LINE_THICKNESS
  },
  showP10: false,
  p50Settings: {
    color: BLACK_HEX,
    thickness: DEFAULT_LINE_THICKNESS
  },
  showP50: false,
  p90Settings: {
    color: BLACK_HEX,
    thickness: DEFAULT_LINE_THICKNESS
  },
  showP90: false,
  pdenDataSourceSetting: {
    source: EvaSource.Public,
    timeStep: TimeStep.Month
  },
  forecastMode: "forecastTrump",
  useForecastStartDate: false,
  survivorBias: true,
  rateType: 0,
  showIndividualSeries: false,
  cutoff: 50,
  timeStep: TimeStep.Month,
  shutInMonths: 3,
  source: EvaSource.Public,
  normalizeBy: DEFAULT_NORMALIZE_BY,
  useWeightedRatioAverage: true,
  xVariable: {
    valueProperty: "Dates.Vintage_Year",
    displayTitle: "Vintage",
    canBin: true,
    dataType: "Integer",
    mappingName: "Dates.Vintage_Year",
    bin: null
  },
  yVariable: {
    valueProperty: "Well_Design.HzLength_m",
    displayTitle: "HzLengthEstimate",
    canBin: true,
    dataType: "Number",
    mappingName: "Well_Design.HzLength_m"
  },
  lockUnits: false,
  movingAverageDays: null
};

export const DEFAULT_DECLINE_RATE_REQUEST: Partial<DeclineRateChartRequestType> = {
  ...BASE_CHART_REQUEST,
  FilterId: "",
  requestId: "",
  ReverseColor: false,
  ColorPalette: {
    id: "-6",
    name: "Portland",
    shared: false,
    colors: ["rgb(12,51,131)"],
    preferredColors: [],
    paletteType: 0,
    colorScale: [],
    specialColors: null,
    thickness: [2],
    reverse: false
  },
  GroupBy: {
    title: "Resource Play",
    property: "Header.ResourcePlay",
    groupByField: "Header.ResourcePlay",
    pdenSource: "Public",
    canBin: false,
    dataType: "Text", // TODO: check this
    categoryId: 1,
    tooltip: "",
    display: "",
    entityKind: EntityKind.Well,
    bin: {
      BinSize: 0,
      MinSize: null,
      MaxBins: null,
      MaxBinsSortOrder: MaxBinsSortOrderEnum.WellCount,
      GreaterThan: null,
      LessThan: null,
      Quantile: {
        quantileType: "NumberOfQuantile",
        numQuantiles: 4
      },
      BinType: "BinSize",
      UseDynamicBins: false
    },
    mode: undefined,
    forecastTrumpingSettings: undefined,
    performanceDateRange: undefined
  },
  sortBy: "AlphabeticalAsc",
  typeWells: [],
  normalizeTypeWell: true,
  userForecast: [],
  userForecastSettings: {
    forecastSourceFolder: null,
    excludeMcDanielForecasts: false,
    reserveCategory: null,
    excludeNoviForecasts: true,
    specialForecastFolders: ["McDaniel Research"]
  },
  forecastMode: "forecastTrump",
  useForecastStartDate: false,
  showGroupsNotInFilter: true,
  placeholderBinsEnabled: false,
  hasCheckedBins: true,
  syncClientPden: false,
  syncClientSchema: "",
  colorLockedItems: {},
  syncClientFcst: false,
  syncForecastRescat: "2111",
  normalizeBySetting: DEFAULT_NORMALIZE_BY_SETTING,
  chartSetting: DEFAULT_DECLINE_RATE_CHART_SETTINGS as DeclineRateChartSettings,
  axisMinMax: {
    xMin: null,
    xMax: null,
    yMin: null,
    yMax: null
  },
  isDefaultLockOn: true
};

export const generateDeclineRateRequestBody = createMergeWithDefaults(
  DEFAULT_DECLINE_RATE_REQUEST
);
